import Cookies from 'js-cookie';
export default class Logout {
    constructor(element) {
        this.passedElement = element;
        this.searchQuery = "";
        this.baseUrl = this.passedElement.getAttribute('data-app-url');
        this.antiforgery = this.passedElement.getAttribute('data-Antiforgery');
        this.init();
    }

    init = () => {
        if (!this.initialised) {
            this.initialised = true;
            this.getElements();
            this.addEventListeners();
        }
    }

    getElements = () => {
        //Query your elements here
        //this.someElement = this.passedElement.querySelector('.some-element');
    }

    addEventListeners = () => {
        //Add all event listeners bellow
        this.passedElement.addEventListener('click', (e) => {
            e.preventDefault();

            // handle the logout of the user here
            fetch(this.baseUrl+'/logout?ReturnPath=/signed-out', {
                credentials: 'include',
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': Cookies.get(this.antiforgery),
                },
            })
            .then((data) =>  data.json())
            .then(payload => {
                window.location.href = payload.redirectUrl;
            });
        });
    }

}